import React from 'react';
import Link from 'gatsby-link';

const NotFoundPage = () => (
  <div className="container page-padding standalone">
    <h1>Page Not Found</h1>
    <p><Link to="/">Return to Homepage</Link></p>
  </div>
)

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.js